import * as yup from "yup";
import { BASIC_AUTHENTICATION_ERROR } from "../constants/errorMessages";
import REGEX from "../constants/constants";
import { COUNTRIES } from "../constants/countryCode";
const getPhoneNumberLength = (dialCode) => {
  const country = COUNTRIES.find((country) => country.dial_code === dialCode);
  return country ? dialCode.length + 7 : 10; // Default length if country not found
};

// Yup validation schema for sign up form using custom error messages
const { EMAIL_PATTERN } = REGEX;
export const signupSchema = yup.object({
  email: yup
    .string()
    .required(BASIC_AUTHENTICATION_ERROR.MSG_EMAIL_USERNAME_REQ)
    .matches(EMAIL_PATTERN, BASIC_AUTHENTICATION_ERROR.EMAIL)
    .max(254, BASIC_AUTHENTICATION_ERROR.MSG_EMAIL_LENGTH),

  password: yup
    .string()
    .required(BASIC_AUTHENTICATION_ERROR.MSG_REQUIRED_PASSWORD)
    .min(8, BASIC_AUTHENTICATION_ERROR.MSG_PASSWORD_TYPE),
  agreeToTerms: yup
    .boolean()
    .oneOf([true], BASIC_AUTHENTICATION_ERROR.AGREE_TERMS_CONDITION),
});
export const loginSchema = yup.object({
  email: yup
    .string()
    .required(BASIC_AUTHENTICATION_ERROR.MSG_EMAIL_USERNAME_REQ)
    .matches(EMAIL_PATTERN, BASIC_AUTHENTICATION_ERROR.EMAIL)
    .max(254, BASIC_AUTHENTICATION_ERROR.MSG_EMAIL_LENGTH),

  password: yup
    .string()
    .required(BASIC_AUTHENTICATION_ERROR.MSG_REQUIRED_PASSWORD)
    .min(8, BASIC_AUTHENTICATION_ERROR.MSG_PASSWORD_TYPE),
});
export const profileSchema = yup
  .object({
    username: yup
      .string()
      .required("Name is mandatory")
      .min(3, "Name must be at least 3 characters")
      .max(50, "Name must be 50 characters or fewer"),

    age: yup
      .number()
      .transform((value, originalValue) => {
        return originalValue === "" ? null : value;
      })
      .nullable()
      .typeError("Age must be a number")
      .positive("Age must be a positive number")
      .integer("Age must be an integer")
      .max(100, "Please enter a valid age"),
    location: yup
      .string()
      .nullable()
      .max(100, "Location must be 100 characters or fewer"),

    sizes: yup
      .string()
      .nullable()
      .transform((value, originalValue) =>
        originalValue === null ? null : value
      ),

    country_code: yup.object().required("Country code is mandatory").nullable(),

    mobile_number: yup
      .string()
      .transform((value, originalValue) =>
        originalValue === null ? null : value
      )
      .required("Mobile number is mandatory")
      .test(
        "Mobile number is mandatory",
        "Mobile number is not valid",
        function (value) {
          const { selectedCountry } = this.parent;
          const phoneLength = getPhoneNumberLength(selectedCountry);
          return value && value.length >= phoneLength;
        }
      )
      .max(13, "Mobile number cannot exceed 13 digits"),
  })
  .required();

export const nameValidationSchema = yup.object({
  name: yup
    .string()
    .required("Name is mandatory")
    .max(50, "Name must be 50 characters or less"),
});

export const editProfileSchema = yup
  .object({
    name: yup
      .string()
      .required("Name is mandatory")
      .min(3, "Name must be at least 3 characters")
      .max(50, "Name must be 50 characters or fewer"),

    age: yup
      .number()
      .transform((value, originalValue) => {
        return originalValue === "" ? null : value;
      })
      .nullable()
      .typeError("Age must be a number")
      .positive("Age must be a positive number")
      .integer("Age must be an integer")
      .max(100, "Please enter a valid age"),
    location: yup
      .string()
      .nullable()
      .max(100, "Location must be 100 characters or fewer"),

    sizes: yup
      .string()
      .nullable()
      .transform((value, originalValue) =>
        originalValue === null ? null : value
      ),

    country_code: yup.object().required("Country code is mandatory").nullable(),

    mobile_number: yup
      .string()
      .transform((value, originalValue) =>
        originalValue === null ? null : value
      )
      .required("Mobile number is mandatory")
      .test(
        "Mobile number is mandatory",
        "Mobile number is not valid",
        function (value) {
          const { selectedCountry } = this.parent;
          const phoneLength = getPhoneNumberLength(selectedCountry);
          return value && value.length >= phoneLength;
        }
      )
      .max(13, "Mobile number cannot exceed 13 digits"),
  })
  .required();
